import axios from 'axios';

const ACTIVE_SHOP_STORAGE_KEY = 'autoclever.activeShopId';

export const getActiveShopId = () => {
  const value = Number(window.localStorage.getItem(ACTIVE_SHOP_STORAGE_KEY) || 0);
  return Number.isInteger(value) && value > 0 ? value : null;
};

export const applyActiveShop = (shopId) => {
  const normalized = Number(shopId || 0);
  if (Number.isInteger(normalized) && normalized > 0) {
    window.localStorage.setItem(ACTIVE_SHOP_STORAGE_KEY, String(normalized));
    axios.defaults.headers.common['X-Shop-Id'] = String(normalized);
    return normalized;
  }

  window.localStorage.removeItem(ACTIVE_SHOP_STORAGE_KEY);
  delete axios.defaults.headers.common['X-Shop-Id'];
  return null;
};

export const activeShopHeaders = () => {
  const shopId = getActiveShopId();
  return shopId ? { 'X-Shop-Id': String(shopId) } : {};
};

export const ACTIVE_SHOP_KEY = ACTIVE_SHOP_STORAGE_KEY;
